import React, { useEffect, useState } from 'react';

import { useHover } from '@uidotdev/usehooks';

export function ResizeHandle({
  position,
  isResizing = false,
  className = '',
  currentWidth,
  minWidth,
  maxWidth,
  hoverDelay = 150,
  ...rest
}) {
  const [ref, hovering] = useHover();
  const [isHovering, setIsHovering] = useState(false);
  const sideClass = position === 'right' ? 'right-0' : 'left-0';

  // Delay hover effect to avoid triggering while mousing around (CSS hover triggers too early).
  useEffect(() => {
    if (hovering) {
      const timeout = setTimeout(() => setIsHovering(true), hoverDelay);
      return () => clearTimeout(timeout);
    } else {
      setIsHovering(false);
    }
  }, [hovering, hoverDelay]);

  const showHighlight = isResizing || isHovering;

  return (
    <div
      ref={ref}
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize panel"
      aria-valuenow={currentWidth}
      aria-valuemin={minWidth}
      aria-valuemax={maxWidth}
      tabIndex={0}
      className={`absolute top-0 bottom-0 ${sideClass} z-(--stack-sidebar-drag-bar) w-1 cursor-ew-resize touch-none select-none ${
        showHighlight ? 'bg-black/30' : ''
      } ${className}`}
      {...rest}
    />
  );
}
